import { Injectable, signal, WritableSignal } from '@angular/core';
import { Notification } from '../interfaces/notification';
import { BaseCrudService } from './base-crud.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends BaseCrudService<Notification, Notification> {

  readonly notifications: WritableSignal<Notification[]> = signal([]);

}
